import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Checkbox } from "@alm/flow-ds/components";
import { OnApplyProps } from "elements/types";
import { createGetElementData } from "../../data/form/elementSelectors";
import { State } from "data";
import { useSelector } from "react-redux";
import { CheckboxElement } from "records/Element";
import { useStandardElement } from "components/Forms/Element";
import DisplayOnlyValue from "elements/DisplayOnlyValue";

function CheckboxOnApply({
	fid,
	vid,
	id,
	index,
	indexes,
	rowIndex,
	uuid,
	hint,
	label,
	required,
	disabled,
	displayOnly,
	isApplyClicked,
	fieldsIsEditedStatus,
	setFieldsIsEditedStatus,
}: OnApplyProps<CheckboxElement>) {
	const getData = useMemo(createGetElementData, []);
	const selectorProps = useMemo(
		() => ({ fid, vid, id, index, indexes, rowIndex, uuid }),
		[fid, vid, id, index, indexes, rowIndex, uuid]
	);
	const data = useSelector((state: State) => getData(state, selectorProps));
	const { eid, setDataAndQueue } = useStandardElement({
		fid,
		vid,
		id,
		index,
		indexes,
		rowIndex,
		uuid,
	});

	// Memoize some values
	const [isChecked, setIsChecked] = useState(
		data && data.value ? true : false
	);

	// onChange callback handler
	const onChange = useCallback(() => {
		// setDataAndQueue(data, { id, value: !isChecked });
		setIsChecked(!isChecked);
		setFieldsIsEditedStatus(prev => ({ ...prev, [uuid]: true }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isChecked]);

	useEffect(() => {
		if (isApplyClicked && fieldsIsEditedStatus[uuid]) {
			setDataAndQueue(data, { id, value: isChecked });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isApplyClicked]);

	// Display only
	if (displayOnly) {
		return <DisplayOnlyValue label={label} value={isChecked.toString()} />;
	}

	return (
		<Checkbox
			id={eid}
			value={isChecked.toString()}
			checked={isChecked}
			onChange={onChange}
			hint={hint}
			feedback={data.feedback}
			required={required}
			label={label}
			disabled={disabled}
			status={data.status}
		/>
	);
}

export default React.memo(CheckboxOnApply);
